<div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0" style="background: #1e1e1e;">
  <h4 class="modal-title" style="color: #ffffff; font-weight: 700;">
    <i class="fa-solid fa-lock me-2" style="color: #00a8ff;"></i>
    {{ isForced ? 'Set Your Password' : 'Change Password' }}
  </h4>
  @if (!isForced) {
    <button type="button" class="close-btn" (click)="modalRef.hide()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }
</div>

<div class="modal-body pb-4" style="background: #1e1e1e; color: #e0e0e0;">
  @if (isForced) {
    <div class="alert alert-warning border-0 mb-4" style="background: rgba(255,193,7,0.15); color: #ffc107; border-radius: 8px;">
      <i class="fa-solid fa-triangle-exclamation me-2"></i>
      <strong>Action Required:</strong> Your password was set by an administrator.
      Please choose a new password before continuing.
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="submit()">
    <!-- New Password -->
    <div class="mb-3">
      <label class="form-label" style="color: #ffffff; font-weight: 500;">New Password</label>
      <div class="input-group">
        <input
          [type]="showNew ? 'text' : 'password'"
          class="form-control"
          style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px 0 0 8px; color: #ffffff; padding: 10px 15px;"
          formControlName="newPassword"
          placeholder="Enter new password"
          autocomplete="new-password"
          />
          <button
            type="button"
            class="btn modern-btn secondary-btn"
            style="border-radius: 0 8px 8px 0; border: 1px solid rgba(255, 255, 255, 0.1); border-left: none; color: #adb5bd;"
            (click)="showNew = !showNew"
            >
            <i [class]="showNew ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
          </button>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="mb-3">
        <label class="form-label" style="color: #ffffff; font-weight: 500;">Confirm Password</label>
        <div class="input-group">
          <input
            [type]="showConfirm ? 'text' : 'password'"
            class="form-control"
            style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px 0 0 8px; color: #ffffff; padding: 10px 15px;"
            formControlName="confirmPassword"
            placeholder="Re-enter new password"
            autocomplete="new-password"
            />
            <button
              type="button"
              class="btn modern-btn secondary-btn"
              style="border-radius: 0 8px 8px 0; border: 1px solid rgba(255, 255, 255, 0.1); border-left: none; color: #adb5bd;"
              (click)="showConfirm = !showConfirm"
              >
              <i [class]="showConfirm ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
            </button>
          </div>
        </div>

        <!-- Validation feedback -->
        @if (passwordErrors.length > 0) {
          <ul class="mt-2 mb-3 ps-3" style="color: #ff6b6b; font-size: 13px;">
            @for (err of passwordErrors; track err) {
              <li>{{ err }}</li>
            }
          </ul>
        }
        @if (form.get('newPassword')?.value?.length >= 8 && hasSpecialChar(form.get('newPassword')?.value) && !form.errors?.['mismatch']) {
          <p style="color: #6bcb77; font-size: 13px;">
            <i class="fa-solid fa-circle-check me-1"></i> Passwords match and meet requirements
          </p>
        }

        <div class="d-flex justify-content-center gap-3 mt-4">
          <button
            type="submit"
            class="btn modern-btn primary-btn"
            style="min-width: 180px; height: 42px;"
            [disabled]="form.invalid || isSubmitting"
            >
            @if (isSubmitting) { <span class="spinner-border spinner-border-sm me-2"></span> }
            {{ isForced ? 'Set Password' : 'Change Password' }}
          </button>
          @if (!isForced) {
            <button type="button" class="btn modern-btn secondary-btn" style="min-width: 120px;" (click)="modalRef.hide()">
              Cancel
            </button>
          }
        </div>
      </form>
    </div>
